/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { log } from 'utils/logger';
import {
    SET_SESSION_DATA,
    SET_USER_GEO_IP,
    RECIEVE_ERRORS,
    OPT_IN,
    EXCLUDE_QUESTIONNAIRE,
    SET_USER_GEO_FROM_SETTINGS
} from 'redux/actions/session_status';
// utils
import { getCookieValue } from 'utils/getCookieValue';
import { isGDPRCountry, getUserGeoSetting } from 'utils/headersettings';


/* ========== ~~~~~~~~~~ SESSION STATUS : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const sessionStatus = (state = {}, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case SET_SESSION_DATA:
            newState = Object.assign({}, newState, action.sessionData);
            return newState;
        case SET_USER_GEO_IP:
            newState = Object.assign({}, newState, action.geoIp );
            if(!newState.userGeo || newState.userGeo === 'UNKNOWN') {
                newState.userGeo = !!action.geoIp && !!action.geoIp.country_code ? action.geoIp.country_code : null;
                newState.GDPRConsentRequired = isGDPRCountry(newState.userGeo);
            }
            return newState;
        case SET_USER_GEO_FROM_SETTINGS:
            newState.userGeo = getUserGeoSetting();
            newState.GDPRConsentRequired = isGDPRCountry(newState.userGeo);
            return newState;
        case OPT_IN:
            newState.userOptedIn = true;
            return newState;
        case EXCLUDE_QUESTIONNAIRE:
            if(action.questionnaire === 'demographic') { return newState }
            newState['excludedQuestionnaires'].push(action.questionnaire);
            return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default sessionStatus;
